// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__5a3Yi","content":"layout_content__InNIU","main":"layout_main__eerbl"};